module.exports = {
  basename: '',
  ecosystems: {
    'single-spa': 'https://cdn.jsdelivr.net/npm/single-spa@5.9.0/lib/system/single-spa.min.js',
    react: 'https://cdnjs.cloudflare.com/ajax/libs/react/17.0.2/umd/react.production.min.js',
    'react-dom': 'https://cdnjs.cloudflare.com/ajax/libs/react-dom/17.0.2/umd/react-dom.production.min.js',
    systemjs: 'https://cdn.jsdelivr.net/npm/systemjs@6.8.0/dist/system.js',
  },
  singleApps: {
    '@microauth/website': 'https://microid.cnnd.vn/microauth-website.js',
    '@microauth/profile': 'https://ms.mediacdn.vn/prod/microauth/profile/dist/microauth-profile.js',
    '@microcoreapps/authentication': 'https://ms.mediacdn.vn/prod/microcoreapps/authentication/dist/microcoreapps-authentication.js',
    '@microcoreapps/layout': 'https://ms.mediacdn.vn/prod/microcoreapps/layout/dist/microcoreapps-layout.js',
    '@microui/react-icons': 'https://ms.mediacdn.vn/prod/microui/react-icons/dist/microui-react-icons.js',
    '@microui/styles': 'https://ms.mediacdn.vn/prod/microui/styles/dist/microui-styles.css',
    '@microui/react-ui': 'https://ms.mediacdn.vn/prod/microui/react-ui/dist/microui-react-ui.js',
  },
  authentication: {
    client_id: 'microid',
    scope: 'microsystem_api',
    connect_tenant: false,
  },
  packageConfig: {
    sso: {
      appName: 'MicroID',
    },
  },
};
